import React, { useRef, useEffect, useState } from "react";
import { isScreenAllowed } from "../../../shared/accessControl.js";
import { api } from "../../../services/api.js";
import { getSnapshotFromResponse } from "../../../services/conteudosApi.js";
function StudentTasks(props) {
  const ref = useRef(null);
  const open = useRef(props.onOpen);
  open.current = props.onOpen;
  const permitted =
    !!props.student?.id && isScreenAllowed(props.student, "tarefas");
  useEffect(() => {
    if (!permitted || !ref.current || !window.DMSchool) return;
    return window.DMSchool.mountStudent(
      ref.current,
      {
        tipo: "aluno",
        data: props.student,
      },
      (target) => open.current(target),
      {
        standalone: !!props.standalone,
        canOpen: isScreenAllowed(props.student, "conteudos"),
      },
    );
  }, [
    permitted,
    props.student?.id,
    props.student?.learning_token,
    props.standalone,
  ]);
  return permitted ? <div ref={ref} /> : null;
}
function StudentTasksPage(props) {
  const [opening, setOpening] = useState(false);
  const [error, setError] = useState("");
  const active = useRef(null);
  useEffect(
    () => () => {
      active.current?.abort();
    },
    [],
  );
  async function open(target) {
    if (opening) return;
    const abort = new AbortController();
    active.current = abort;
    setOpening(true);
    setError("");
    try {
      let course = props.ctx.conteudos?.cursos?.find(
        (item) => String(item.id) === String(target.cursoId),
      );
      if (!course) {
        const response = await api.get("/conteudos/aluno", {
          signal: abort.signal,
        });
        const snapshot = getSnapshotFromResponse(response).snapshot;
        course = snapshot.cursos.find(
          (curso) => String(curso.id) === String(target.cursoId),
        );
        if (!course)
          throw Error("A aula indicada não está disponível no seu acesso.");
        const category = snapshot.categorias.find(
          (categoria) => String(categoria.id) === String(course.cat_id),
        );
        props.ctx.setConteudos((previous) => ({
          ...previous,
          cursos: [
            ...previous.cursos.filter(
              (curso) => String(curso.id) !== String(course.id),
            ),
            course,
          ],
          categorias: category
            ? [
                ...previous.categorias.filter(
                  (categoria) => String(categoria.id) !== String(category.id),
                ),
                category,
              ]
            : previous.categorias,
        }));
      }
      if (abort.signal.aborted) return;
      props.ctx.setConteudosNavigationTarget({
        ...target,
        cursoId: course.id,
      });
      props.ctx.goto("conteudos");
    } catch (err) {
      if (!abort.signal.aborted)
        setError(
          err.message || "Não foi possível abrir a aula. Tente novamente.",
        );
    } finally {
      if (!abort.signal.aborted) setOpening(false);
    }
  }
  return (
    <main className={"ct dm-student-tasks-page"}>
      {opening ? (
        <p className={"ds-loading"} role={"status"}>
          {"Abrindo aula…"}
        </p>
      ) : null}
      {error ? (
        <p className={"ds-message"} role={"alert"}>
          {error}
        </p>
      ) : null}
      <StudentTasks student={props.student} standalone={true} onOpen={open} />
    </main>
  );
}
export { StudentTasks, StudentTasksPage };
